CheckedOutController.$inject = []
function CheckedOutController(){

}

export default CheckedOutController
